import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import { LuWarehouse, LuNavigation } from 'react-icons/lu';
import api from '../../services/api';
import ModalShell from '../ui/ModalShell';
import MapaLeaflet, { linkWaze } from './MapaLeaflet';

// "Volver al depósito" (29-oct-2026): desde donde estás (GPS del celu) hasta el depósito que está en
// Finanzas → Ajustes. Muestra el tramo en el mapa y abre Google Maps o Waze.
function ubicacion() {
    return new Promise((ok) => {
        if (!navigator.geolocation) { ok(null); return; }
        navigator.geolocation.getCurrentPosition(p => ok({ lat: p.coords.latitude, lng: p.coords.longitude }), () => ok(null),
            { enableHighAccuracy: true, timeout: 8000, maximumAge: 60000 });
    });
}
const kmAprox = (a, b) => {
    const r = 6371, rad = x => (x * Math.PI) / 180;
    const d = Math.sin(rad(b.lat - a.lat) / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(rad(b.lng - a.lng) / 2) ** 2;
    return Math.round(2 * r * Math.asin(Math.sqrt(d)) * 1.3 * 10) / 10;   // × 1,3: de línea recta a calles
};

export default function VolverDeposito({ className = '' }) {
    const [datos, setDatos] = useState(null);   // { yo, dep }
    const [buscando, setBuscando] = useState(false);

    const abrir = async () => {
        setBuscando(true);
        try {
            const [yo, r] = await Promise.all([ubicacion(), api.get('/rentabilidad/deposito')]);
            if (r.data?.lat == null) { toast.error('No encuentro el depósito en el mapa: revisá la dirección en Finanzas → Ajustes'); return; }
            setDatos({ yo, dep: r.data });
        } catch { toast.error('No se pudo buscar el depósito'); }
        finally { setBuscando(false); }
    };

    const dep = datos?.dep;
    const yo = datos?.yo;
    const google = dep && `https://www.google.com/maps/dir/?api=1&destination=${dep.lat},${dep.lng}${yo ? `&origin=${yo.lat},${yo.lng}` : ''}`;
    const puntos = !datos ? [] : [
        ...(yo ? [{ id: 'yo', lat: yo.lat, lng: yo.lng, color: '#2563EB', etiqueta: '•', titulo: 'Estás acá', tituloFijo: true }] : []),
        { id: 'dep', lat: dep.lat, lng: dep.lng, color: '#111827', etiqueta: 'D', titulo: dep.nombre || 'Depósito', tituloFijo: true },
    ];
    return (
        <>
            <button type="button" onClick={abrir} disabled={buscando}
                className={`h-9 px-3 shrink-0 rounded-xl inline-flex items-center gap-1.5 bg-chip text-ink text-label font-black active:scale-95 disabled:opacity-50 ${className}`}>
                <LuWarehouse size={15} /> {buscando ? 'Buscando…' : 'Volver al depósito'}
            </button>
            {datos && (
                <ModalShell titulo="Volver al depósito" subtitulo={dep.direccion} onCerrar={() => setDatos(null)}
                    pie={
                        <div className="flex gap-2">
                            <a href={google} target="_blank" rel="noreferrer" data-sin-elegir
                                className="flex-1 h-12 rounded-xl bg-brand-red text-white text-label font-black inline-flex items-center justify-center gap-1.5 active:scale-95">
                                <LuNavigation size={15} /> Google Maps
                            </a>
                            <a href={linkWaze(dep.direccion, dep.lat, dep.lng)} target="_blank" rel="noreferrer"
                                className="flex-1 h-12 rounded-xl bg-[#33CCFF] text-[#0B2A3A] text-label font-black inline-flex items-center justify-center gap-1.5 active:scale-95">
                                <LuNavigation size={15} /> Waze
                            </a>
                        </div>
                    }>
                    <div className="space-y-3">
                        <div className="rounded-2xl overflow-hidden border border-black/[0.06] dark:border-white/[0.06]">
                            <MapaLeaflet puntos={puntos} lineas={yo ? [[yo.lat, yo.lng], [dep.lat, dep.lng]] : null} ajustarKey={`dep-${yo ? 1 : 0}`} className="w-full h-64" />
                        </div>
                        <p className="text-body text-ink">
                            {yo ? <>Estás a unos <b>{kmAprox(yo, dep)} km</b> de {dep.nombre || 'el depósito'}.</>
                                : 'No pude leer tu ubicación: Google Maps y Waze salen desde donde estés.'}
                        </p>
                        <p className="text-caption text-muted">La dirección del depósito se cambia en Finanzas → Ajustes.</p>
                    </div>
                </ModalShell>
            )}
        </>
    );
}
